import { ChainId, MainnetChainId, TestnetChainId, viemChains } from '@endure/chains';
import type { Chain } from 'viem';

import localConfig from 'config';
import { extractEnumValues } from 'utilities/extractEnumValues';

const getSupportedChains = () => {
  const chainIds = (() => {
    if (localConfig.network === 'local') {
      return [ChainId.LOCAL];
    }

    if (localConfig.network === 'bittensor_testnet') {
      return [ChainId.BITTENSOR_TESTNET];
    }

    return localConfig.network === 'testnet'
      ? extractEnumValues(TestnetChainId)
      : extractEnumValues(MainnetChainId);
  })();

  const chains: Chain[] = chainIds.map((chainId) => {
    const chain = viemChains[chainId];
    const rpcUrls = localConfig.rpcUrls[chainId];

    return {
      ...chain,
      rpcUrls: {
        ...chain.rpcUrls,
        default: {
          ...chain.rpcUrls.default,
          http: rpcUrls,
        },
      },
    };
  });

  return chains;
};

export const governanceChainId =
  localConfig.network === 'local'
    ? ChainId.LOCAL
    : localConfig.network === 'bittensor_testnet'
      ? ChainId.BITTENSOR_TESTNET
      : localConfig.network === 'testnet'
        ? ChainId.BSC_TESTNET
        : ChainId.BSC_MAINNET;

export const chains = getSupportedChains();

// safe-by-chains-config: getSupportedChains() always returns >=1 chain per branch
export const defaultChain = chains[0]!;
